import { AxiosInstance } from 'axios';
import { create } from 'zustand';

export type HttpClient = AxiosInstance;

interface HttpStoreValue {
	data: HttpClient | null;
	rcs: HttpClient | null;
	v1: HttpClient | null;
	v2: HttpClient | null;
}

export type HttpClientKey = keyof HttpStoreValue;

export const useHttpStore = create<HttpStoreValue>(() => ({
	data: null,
	rcs: null,
	v1: null,
	v2: null,
}));
